import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';

export function FavoriteButton({
  isFavorite,
  onClick,
  theme = 'fill_secondary',
  size = 'XS',
  hideText = false,
  isHeader = false,
}: IFavoriteButtonProps) {
  const iconColor = isFavorite
    ? 'accent-negative-primary'
    : isHeader
      ? 'icon-primary-default'
      : theme === 'stroke_secondary'
        ? 'icon-inverted-default'
        : theme === 'stroke_primary'
          ? 'icon-main-default'
          : 'icon-negative-default';
  const icon = isFavorite ? <IconToggleHeartOn16 color={iconColor} /> : <IconToggleHeartOff16 color={iconColor} />;
  const label = isFavorite ? 'В избранном' : 'В избранное';
  const dataTestId = isHeader ? `FavoriteButtonIcon${isFavorite ? 'On' : 'Off'}` : 'FavoriteButton';

  return (
    <Button theme={theme} onClick={onClick} beforeIcon={icon} size={size} data-testid={dataTestId}>
      {hideText ? '' : label}
    </Button>
  );
}
